export default __webpack_public_path__ + "static/media/BeforePhoto10.a0a9d0fe.jpg";